import DashBoard from "pages/LandingPages/DashBoard";

export default function Dashboard() {
    return <DashBoard />;
}